// extracted by mini-css-extract-plugin
module.exports = {"maindiv":"Wallets_maindiv__1mpqD","heading":"Wallets_heading__3O9pQ","wallet_list":"Wallets_wallet_list__oBsai"};